import type { DataLayerEvent } from "@repo/design-system/types/tracking";
import { env } from "~/setup/env";

export function dataLayerPush(data: DataLayerEvent) {
  if (env.ENVIRONMENT === "development") {
    console.log("Tracking Event:", data);
  }

  if (!env.NEXT_PUBLIC_GA_TRACKING || env.ENVIRONMENT !== "production") {
    return;
  }

  if (typeof window === "undefined") {
    return;
  }
  // Initialise the dataLayer queue before pushing: GTM now loads with
  // strategy="lazyOnload" (on browser idle), so window.dataLayer may not exist
  // yet when an early tracking event fires. Pushes queue here and GTM drains
  // them on load. (window.dataLayer is typed non-optional but is undefined at
  // runtime until GTM's snippet runs — this guard prevents a hard crash.)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}
